import React from 'react';

import * as S from './styles';

export interface ScrollingSectionProps {
	label?: string;
	children?: React.ReactNode | React.ReactNode[];
}

const ScrollingSection = ({ label, children }: ScrollingSectionProps) => {
	return (
		<>
			<S.Base>
				{label && <S.Label>{label}</S.Label>}
				<S.Children>{children}</S.Children>
			</S.Base>
		</>
	);
};

export default ScrollingSection;
